import React from "react";
import { BillingTable, BillingTableContent, RowItem, TableContent } from "./style";
import { Heading4, Heading6 } from "components/text/heading/style";
import billing_theme from "style/theme_colors";
import { Body3 } from "components/text/body/style";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { MaoObra } from "shared/models/fatura_response.model";
import { toMoney } from "utils/numberUtils";
import { toDate } from "utils/stringUtils";
import { NoContentTable } from "../../style";

const ViewFaturaMaoDeObraTable: React.FC = () => {
  const viewFatura = useSelector((state: RootState) => state.view_fatura);

  return (
    <TableContent>
      <Heading4 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
        Mão de obra
      </Heading4>
      {viewFatura.Objeto.MaoObras.length == 0 && (
        <NoContentTable>
          <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
            Nenhuma item a ser mostrado!
          </Heading6>
        </NoContentTable>
      )}
      {viewFatura.Objeto.MaoObras.length != 0 && (
        <BillingTableContent>
          <BillingTable>
            <thead>
              <HeadTable />
            </thead>
            <tbody>
              {viewFatura.Objeto.MaoObras.map(el => (
                <ItemMaoDeObra key={el.ID} estoque={el} />
              ))}
            </tbody>
          </BillingTable>
        </BillingTableContent>
      )}
    </TableContent>
  );
};
const HeadTable: React.FC = () => {
  return (
    <tr>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Numero de contrato
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Numero de serie
        </Heading6>
      </td>

      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Placa
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Tipo
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Data
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Observações
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Instalador
        </Heading6>
      </td>
      <td>
        <Heading6 color={billing_theme.pallete.tertiary.A400} fontWeight={500}>
          Valor
        </Heading6>
      </td>
    </tr>
  );
};
const ItemMaoDeObra: React.FC<{ estoque: MaoObra }> = ({ estoque }) => {
  return (
    <RowItem>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {estoque.NumeroContratoBilling}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {estoque.NumeroSerie}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {estoque.Placa}
        </Body3>
      </td>

      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {estoque.Tipo}
        </Body3>
      </td>

      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {toDate(estoque.Data)}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {estoque.Observacoes}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {estoque.Instalador}
        </Body3>
      </td>
      <td>
        <Body3 color={billing_theme.pallete.tertiary.A400} fontWeight={600}>
          {toMoney(estoque.Valor)}
        </Body3>
      </td>
    </RowItem>
  );
};
export default ViewFaturaMaoDeObraTable;
